import React, { Component } from 'react'
import './ranking-position.css'
import './ranking-list.css'

class RankingList extends Component {
  render() {
    const { list } = this.props
    let position = 4
    let lastScore = null
    return (
      <ul className="ranking-list">
        {list.map((item, index) => {
          const { name, score } = item
          const shouldRender = name && score > 0
          if (index > 0) {
            position = score !== lastScore ? position + 1 : position
          }

          lastScore = score
          return shouldRender ? (
            <li key={index} className="ranking-list-item">
              <div className="flex-center">
                <div className="position-counter flex-align-center rounded rounded-sm rounded-position bg-blue">
                  <span className="position-number">{position}</span>
                </div>
                <div className="position-info">
                  <h3>{name}</h3>
                </div>
              </div>
            </li>
          ) : null
        })}
      </ul>
    )
  }
}

export default RankingList



// WEBPACK FOOTER //
// ./src/components/rankingList.js